import { render, staticRenderFns } from "./ShiftPatternDetails.vue?vue&type=template&id=8ec35a60&scoped=true"
import script from "./ShiftPatternDetails.vue?vue&type=script&lang=js"
export * from "./ShiftPatternDetails.vue?vue&type=script&lang=js"
import style0 from "./ShiftPatternDetails.vue?vue&type=style&index=0&id=8ec35a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec35a60",
  null
  
)

export default component.exports